import React from 'react';

export const Summary = props => {
	const { body, guestMode } = props;
	return (
		<div>
			{/*show when not in guestMode*/}
			{/* { !guestMode && <p className="p-tag section-visibility-info">Profile summary is specific to the current network.</p> } */}
			{/*//////////////////////////*/}
			<div className="profile-summary-body">
				{body && <p dangerouslySetInnerHTML={{ __html: body }} />}
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/Summary.js